export function useImageCdn() {

    interface ImgBindings {
        src: string;
        sizes: string;
        srcset: string;
    }

    const runtimeConfig = useRuntimeConfig();

    const getImageUrl = (path: string) : string => {
        return `${runtimeConfig.public.wadCdnRoot}${path}`;
    };

    const fixedWidthImageParams = (imageUrl: string, imageWidth: number, ar: number|null = null, customParams: string|null = '') : ImgBindings => {
        let imgixCommonParams = `auto=compress,format${customParams}`;
        if(ar) {
            imgixCommonParams = `ar=${ar}&fit=crop&crop=entropy&${imgixCommonParams}`
        }
        return <ImgBindings>{
            src: `${imageUrl}?w=${imageWidth}&${imgixCommonParams}`,
            sizes: `${imageWidth}`,
            srcset: `${imageUrl}?w=${imageWidth}&dpr=1&${imgixCommonParams} 1x,
                     ${imageUrl}?w=${imageWidth}&dpr=2&${imgixCommonParams} 2x,
                     ${imageUrl}?w=${imageWidth}&dpr=3&${imgixCommonParams} 3x,
                     ${imageUrl}?w=${imageWidth}&dpr=4&${imgixCommonParams} 4x`,
        };
    };

    return {
        getImageUrl,
        fixedWidthImageParams
    }
}
